import { BlocCoordinator } from "@lib/bloc/BlocCoordinator";
import { responsiveFontSizes } from "@material-ui/core";
import { Asset, labelForAsset } from "@model/assets/Asset";
import {
    CollapsibleFormField,
    FormField,
    FormFieldDirection,
    FormFieldNote,
    FormFieldNoteType,
} from "@ui/common/form/FormField"
import { SearchableTextInput } from "@ui/common/form/SearchableTextInput"
import { DI } from "@ui/DI";
import React from "react";

export type AssetSearchProps = {
    onSelectedAssetChanged: (asset: Asset | null) => void
    selectedAsset?: Asset | null
    isEnabled?: boolean | null
}

export function AssetSearch(props: AssetSearchProps): JSX.Element {
    const { onSelectedAssetChanged, selectedAsset } = props
    const [isSearchingForAssets, setIsSearchingForAssets] = React.useState(false)
    const [availableAssets, availableAssetsChanged] = React.useState<Asset[]>([])
    const assetService = DI.assetService();

    async function searchAssets(search: string) {
        setIsSearchingForAssets(true)
        const outcome = await assetService.searchAssets(search, true)

        if (outcome.isOk()) {
            availableAssetsChanged(outcome.value)
        }

        setIsSearchingForAssets(false)
        return outcome
    }

    return (
        <FormField label="Asset ID, VIN, or Serial*" direction={FormFieldDirection.Column}>
            <SearchableTextInput
                options={availableAssets.map((asset) => ({
                    label: labelForAsset(asset),
                    value: asset,
                    key: asset.id,
                }))}
                isLoading={isSearchingForAssets}
                isEnabled={props.isEnabled ?? true}
                value={selectedAsset?.label ?? ""}
                emptyMessage={"No assets found"}
                debounceMillis={250}
                minSearchCharacters={3}
                onSearchChanged={async (search) => await searchAssets(search)}
                onOptionSelected={(option) =>
                    onSelectedAssetChanged(option.value)
                }
            />
            {props.isEnabled && <FormFieldNote inset={true}>Type to search through available assets in your fleet.</FormFieldNote>}
        </FormField>
    )
}

